export enum LookerMemberManagementDashboardType {
  Member_Management = 655,
  Membership_History = 659,
}
